var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-page-wrapper d-error-page"},[_c('div',{staticClass:"d-error-page-title",domProps:{"innerHTML":_vm._s(_vm.$t('accessDeniedPage.title'))}}),_c('div',{staticClass:"d-error-page-message",domProps:{"innerHTML":_vm._s(_vm.$t('accessDeniedPage.message'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }